<template>
  <div class="bento-layout feedback-page">
    <div class="container py-4">
      <div class="row">
        <!-- Left: Input Module -->
        <div class="col-lg-4 mb-4">
          <div class="bento-card input-card sticky-top" style="top: 20px;">
              <div class="card-header-simple">
                <span class="header-icon">✍️</span>
                <span class="header-text">提交新建议</span>
              </div>

            
            <div class="input-group-custom mt-3">
              <textarea 
                v-model="fbContent" 
                class="bento-input" 
                placeholder="在此输入您的宝贵建议..."
                rows="5"
              ></textarea>
            </div>

            <!-- Upload Area -->
            <div class="upload-minimal mt-3" @click="$refs.fileInput.click()">
              <input ref="fileInput" type="file" hidden accept="image/*" @change="onUpload" />
              <div v-if="fbImages.length === 0" class="upload-placeholder">
                <span class="icon">🖼️</span>
                <span class="text">添加截图 (可选)</span>
              </div>
              <div v-else class="upload-previews">
                <div v-for="(url, idx) in fbImages" :key="idx" class="mini-preview">
                  <img :src="url" />
                  <div class="remove" @click.stop="removeImage(idx)">×</div>
                </div>
                <div class="add-more">+</div>
              </div>
            </div>

            <div class="mt-4">
              <button 
                class="btn-bento btn-primary-bento w-100" 
                @click="onSubmit" 
                :disabled="submitting"
              >
                <span v-if="!submitting">发送反馈</span>
                <span v-else class="spinner-border spinner-border-sm"></span>
              </button>
              <div class="alert-bento mt-2" v-if="fbMsg">{{ fbMsg }}</div>
            </div>
            
            <div class="user-footer mt-4 border-top pt-3 text-center">
              <div class="text-muted extra-small">OPERATOR: <span class="font-weight-bold">{{ currentUserName || 'GUEST' }}</span></div>
            </div>
          </div>
        </div>

        <!-- Right: Feed Module -->
        <div class="col-lg-8">
          <div class="feed-header mb-3 d-flex align-items-center">
            <h2 class="h6 font-weight-bold mb-0">实时建议流</h2>
            <div class="line flex-grow-1 mx-3"></div>
            <span class="text-muted extra-small monospace">STREAM_LIVE</span>
          </div>

          <div v-if="feedbackList.length === 0" class="empty-state bento-card">
            <div class="empty-icon">📭</div>
            <div class="text-muted">暂无建议记录，等待数据注入...</div>
          </div>

          <div class="bento-feed">
            <div v-for="item in feedbackList" :key="item.id" class="bento-card signal-item mb-3">
              <div class="signal-header d-flex align-items-center mb-2">
                <div class="user-avatar-mini mr-2">{{ item.username ? item.username.charAt(0).toUpperCase() : 'U' }}</div>
                <div class="user-meta">
                  <div class="user-name font-weight-bold small">{{ item.username }}</div>
                  <div class="signal-date monospace extra-small text-muted">{{ formatShortTime(item.created_time) }}</div>
                </div>
                <div class="ml-auto d-flex align-items-center">
                  <button v-if="currentUserId===item.user_id" class="btn-plain mr-2" @click="deleteFeedback(item)">🗑️</button>
                  <div class="like-pill" :class="{'liked': item.liked_by_me}" @click="toggleFeedbackLike(item)">
                    <span class="icon">👍</span>
                    <span class="count monospace">{{ item.likes || 0 }}</span>
                  </div>
                </div>
              </div>

              <div class="signal-body">
                <p class="content-text mb-2">{{ item.content }}</p>
                <div class="image-grid-bento" v-if="item.images && item.images.length">
                  <img 
                    v-for="(url, idx) in item.images" 
                    :key="idx" 
                    :src="fullUrl(url)" 
                    class="bento-img"
                    @click="openImage(fullUrl(url))"
                  />
                </div>
              </div>

              <!-- Comments Section -->
              <div class="signal-footer border-top mt-3 pt-3">
                <div class="comments-mini mb-3" v-if="item.comments && item.comments.length">
                  <div v-for="c in item.comments" :key="c.id" class="comment-item-bento mb-2">
                    <span class="comment-user font-weight-bold">{{ c.username }}:</span>
                    <span class="comment-text mx-1">{{ c.content }}</span>
                    <span class="comment-like-mini" @click="toggleLike(c)" :class="{'active': c.liked_by_me}">
                      ❤️ {{ c.likes || 0 }}
                    </span>
                  </div>
                </div>

                <div class="reply-box-bento">
                  <input 
                    v-model="commentInputs[item.id]" 
                    placeholder="写下您的看法..." 
                    class="reply-input-bento"
                    @keyup.enter="submitComment(item.id)"
                  />
                  <button class="btn-send-mini" @click="submitComment(item.id)" :disabled="!commentInputs[item.id]">
                    <span class="icon">🚀</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Image Modal -->
    <b-modal ref="imageViewer" hide-footer centered size="xl" body-class="p-0 bento-modal">
      <div class="image-container">
        <img :src="imageViewerSrc" class="img-fluid" @click="$refs.imageViewer.hide()" />
      </div>
    </b-modal>
  </div>
</template>

<script>
import { request_zzquant } from "network/request.js"
import moment from 'moment'

export default {
  data(){
    return { 
      fbContent:'', 
      fbFile:null, 
      fbImages:[], 
      fbMsg:'', 
      submitting:false, 
      feedbackList:[], 
      commentInputs:{}, 
      currentUserId:null, 
      currentUserName:null, 
      deleteIcon: require('assets/img/delete.png'), 
      imageViewerSrc:'',
      currentTime: moment().format('HH:mm:ss')
    }
  },
  mounted(){ 
    this.loadUser(); 
    this.loadList();
    this.timer = setInterval(() => {
      this.currentTime = moment().format('HH:mm:ss')
    }, 1000)
  },
  beforeDestroy() {
    if(this.timer) clearInterval(this.timer)
  },
  methods:{
    onUpload(e){
       const file = e.target.files[0]
       if(!file){ return }
       const form = new FormData()
       form.append('file', file)
       request_zzquant({ url: '/feedback/upload', method: 'POST', data: form, headers: { 'Content-Type': 'multipart/form-data' } })
         .then(res => { 
           const url = res.data && res.data.data ? res.data.data.url : null; 
           if(url){ 
             const full = 'https://api.zizizaizai.com' + url; 
             this.fbImages.push(full); 
           } 
         })
         .catch(() => { this.fbMsg = '图片上传失败'; })
    },
    openImage(url){ this.imageViewerSrc = url; try{ this.$refs.imageViewer.show() }catch(e){ void 0 } },
    removeImage(idx){
       this.fbImages.splice(idx, 1);
    },
    loadUser(){
      request_zzquant({ url:'/user/info', method:'GET' }).then(res=>{ 
        const d=res.data&&res.data.data?res.data.data:{}; 
        this.currentUserId=d.id||null; 
        this.currentUserName=d.username||null; 
        this.applyLikeMarks() 
      }).catch(()=>{ 
        this.currentUserId=null; 
        this.currentUserName=null; 
      })
    },
     onSubmit(){
       if(!this.fbContent || this.fbContent.trim()===''){ this.fbMsg='请输入内容'; return }
       this.submitting=true
       request_zzquant({ url:'/feedback/submit', method:'POST', data:{ content:this.fbContent.trim(), images:this.fbImages } })
         .then(() => { 
           this.fbMsg='提交成功！'; 
           this.fbContent=''; 
           this.fbImages=[]; 
           this.submitting=false; 
           this.loadList(); 
           setTimeout(() => { this.fbMsg = '' }, 3000)
         })
         .catch(() => { this.fbMsg='提交失败，请重试'; this.submitting=false; })
     },
    loadList(){
      request_zzquant({ url:'/feedback/list', method:'GET' })
        .then(res => { 
          const data = res.data && res.data.data ? res.data.data : []; 
          this.feedbackList = Array.isArray(data) ? data : []; 
          this.normalizeLikes(); 
          this.applyLikeMarks() 
        })
        .catch(() => {})
    },
    normalizeLikes(){
      for(const item of this.feedbackList){ 
        item.liked_by_me = typeof item.liked_by_me==='boolean' ? item.liked_by_me : !!(item.liked || item.my_liked || item.liked_me || item.like_by_me); 
        const cs = Array.isArray(item.comments) ? item.comments : []; 
        for(const c of cs){ c.liked_by_me = typeof c.liked_by_me==='boolean' ? c.liked_by_me : !!(c.liked || c.my_liked || c.liked_me || c.like_by_me) } 
      }
    },
    applyLikeMarks(){
      const uid = this.currentUserId || 0; if(!uid) return;
      const itemLiked = this._getLikedSet('fb_item');
      const cLiked = this._getLikedSet('fb_comment');
      for(const item of this.feedbackList){
        if(Array.isArray(item.liked_user_ids)){ item.liked_by_me = item.liked_by_me || item.liked_user_ids.includes(uid) }
        if(itemLiked.has(item.id)) item.liked_by_me = true;
        const cs = Array.isArray(item.comments) ? item.comments : [];
        for(const c of cs){ if(Array.isArray(c.liked_user_ids)){ c.liked_by_me = c.liked_by_me || c.liked_user_ids.includes(uid) } if(cLiked.has(c.id)) c.liked_by_me = true; }
      }
    },
    _getLikedSet(type){
      const uid = this.currentUserId || 0; const key = `zzq_${type}_liked_${uid}`;
      try{ const raw = localStorage.getItem(key) || '[]'; const arr = JSON.parse(raw); if(Array.isArray(arr)) return new Set(arr); }catch(e){ return new Set() }
      return new Set();
    },
    _saveLikedSet(type, set){
      const uid = this.currentUserId || 0; const key = `zzq_${type}_liked_${uid}`; try{ localStorage.setItem(key, JSON.stringify(Array.from(set))) }catch(e){ void 0 }
    },
     submitComment(fid){
       const text = (this.commentInputs[fid] || '').trim(); if(!text){ return }
       request_zzquant({ url:'/feedback/comment', method:'POST', data:{ feedback_id: fid, content: text } })
         .then(() => { this.$set(this.commentInputs, fid, ''); this.loadList(); })
         .catch(() => {})
     },
     deleteFeedback(item){
       if(!confirm('确定删除此反馈吗？')) return;
       request_zzquant({ url:'/feedback/delete', method:'POST', data:{ feedback_id: item.id } })
         .then(()=>{ this.loadList() })
         .catch(()=>{})
     },
    toggleFeedbackLike(item){
      request_zzquant({ url:'/feedback/like', method:'POST', data:{ feedback_id: item.id } })
        .then(res=>{ 
          const d=res.data&&res.data.data?res.data.data:{}; 
          item.likes=d.likes; 
          item.liked_by_me=d.liked; 
          const set = this._getLikedSet('fb_item'); 
          if(d.liked){ set.add(item.id) } else { set.delete(item.id) } 
          this._saveLikedSet('fb_item', set) 
        })
        .catch(()=>{})
    },
    toggleLike(c){
      request_zzquant({ url:'/feedback/comment/like', method:'POST', data:{ comment_id: c.id } })
        .then(res => { 
          const d=res.data&&res.data.data?res.data.data:{}; 
          c.likes=d.likes; 
          c.liked_by_me=d.liked; 
          const set = this._getLikedSet('fb_comment'); 
          if(d.liked){ set.add(c.id) } else { set.delete(c.id) } 
          this._saveLikedSet('fb_comment', set) 
        })
        .catch(() => {})
    },
     deleteComment(c){
       request_zzquant({ url:'/feedback/comment/delete', method:'POST', data:{ comment_id: c.id } })
         .then(()=>{ this.loadList() })
         .catch(()=>{})
     },
    fullUrl(url){ if(!url){ return '' } if(url.startsWith('http')) return url; return 'https://api.zizizaizai.com' + url },
    formatShortTime(t) { return t ? t.substring(5, 16) : '--:--' }
  }
}
</script>

<style>
/* Bento 主题变量 */
.bento-layout {
  --bento-bg: #f8fafc;
  --bento-card-bg: #ffffff;
  --bento-border: #e2e8f0;
  --bento-text: #1e293b;
  --bento-text-muted: #64748b;
  --bento-accent: #3b82f6;
  --bento-up: #ef4444;
  --bento-down: #22c55e;
  --bento-radius: 12px;
  --bento-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);

  background-color: var(--bento-bg);
  color: var(--bento-text);
  min-height: 100vh;
}

body.theme-dark .bento-layout {
  --bento-bg: #0f172a;
  --bento-card-bg: #1e293b;
  --bento-border: #334155;
  --bento-text: #f1f5f9;
  --bento-text-muted: #94a3b8;
  --bento-accent: #60a5fa;
  --bento-up: #f87171;
  --bento-down: #4ade80;
  --bento-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.3);
}
</style>

<style scoped>
.monospace { font-family: 'IBM Plex Mono', 'Consolas', monospace; }
.extra-small { font-size: 10px; }

/* Bento Components */
.bento-card {
  background: var(--bento-card-bg);
  border: 1px solid var(--bento-border);
  border-radius: var(--bento-radius);
  padding: 1.25rem;
  box-shadow: var(--bento-shadow);
  transition: transform 0.2s, box-shadow 0.2s;
}
.bento-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
}

/* Input Card */
.card-header-simple { display: flex; align-items: center; gap: 8px; font-weight: bold; }
.bento-input {
  width: 100%;
  background: var(--bento-bg);
  border: 1px solid var(--bento-border);
  border-radius: 8px;
  padding: 12px;
  color: var(--bento-text);
  font-size: 14px;
  outline: none;
  resize: none;
}
.bento-input:focus { border-color: var(--bento-accent); }

.upload-minimal {
  background: var(--bento-bg);
  border: 1px dashed var(--bento-border);
  border-radius: 8px;
  padding: 10px;
  cursor: pointer;
  text-align: center;
}
.upload-placeholder { color: var(--bento-text-muted); font-size: 13px; }
.upload-previews { display: flex; flex-wrap: wrap; gap: 8px; }
.mini-preview { width: 40px; height: 40px; position: relative; border-radius: 4px; overflow: hidden; }
.mini-preview img { width: 100%; height: 100%; object-fit: cover; }
.mini-preview .remove { position: absolute; top: 0; right: 0; background: rgba(0,0,0,0.5); color: #fff; width: 15px; height: 15px; font-size: 10px; text-align: center; cursor: pointer; }
.add-more { width: 40px; height: 40px; border: 1px dashed var(--bento-border); border-radius: 4px; display: flex; align-items: center; justify-content: center; color: var(--bento-text-muted); }

.btn-bento { border: none; border-radius: 8px; padding: 10px; font-weight: bold; transition: all 0.2s; }
.btn-primary-bento { background: var(--bento-accent); color: #fff; }
.btn-primary-bento:hover { opacity: 0.9; transform: scale(1.02); }
.btn-primary-bento:disabled { background: var(--bento-border); }

/* Feed Section */
.line { height: 1px; background: var(--bento-border); }
.user-avatar-mini { width: 32px; height: 32px; background: var(--bento-accent); color: #fff; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-weight: bold; }

.like-pill {
  background: var(--bento-bg);
  border: 1px solid var(--bento-border);
  padding: 4px 10px;
  border-radius: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  transition: all 0.2s;
}
.like-pill.liked { border-color: var(--bento-up); color: var(--bento-up); background: rgba(239, 68, 68, 0.05); }
.like-pill:hover { transform: scale(1.05); }

.image-grid-bento { display: flex; flex-wrap: wrap; gap: 8px; }
.bento-img { width: 80px; height: 80px; object-fit: cover; border-radius: 8px; border: 1px solid var(--bento-border); cursor: pointer; }

.comment-item-bento { font-size: 13px; padding-left: 10px; border-left: 2px solid var(--bento-border); }
.comment-like-mini { font-size: 11px; cursor: pointer; color: var(--bento-text-muted); margin-left: 5px; }
.comment-like-mini.active { color: var(--bento-up); }

.reply-box-bento {
  display: flex;
  background: var(--bento-bg);
  border-radius: 20px;
  padding: 4px 12px;
  border: 1px solid var(--bento-border);
}
.reply-input-bento { flex: 1; background: transparent; border: none; font-size: 13px; color: var(--bento-text); outline: none; }
.btn-send-mini { background: transparent; border: none; cursor: pointer; }

.btn-plain { background: transparent; border: none; opacity: 0.5; transition: opacity 0.2s; }
.btn-plain:hover { opacity: 1; }

.empty-state { text-align: center; padding: 3rem; }
.empty-icon { font-size: 3rem; margin-bottom: 1rem; }

/* Responsive */
@media (max-width: 576px) {
  .hidden-mobile { display: none; }
}

.bento-modal :global(.modal-content) { background: #000; border-radius: 0; }
.image-container { display: flex; align-items: center; justify-content: center; height: 80vh; }
</style>
